/**
 * Czy pokazywać kupowanie / doładowywanie kredytów.
 *
 * Decyzja 2026-08-23: płatności ODSŁONIĘTE dla wszystkich (koniec fazy „testy bez
 * płatności" z 2026-07-31 — wtedy cennik widział tylko admin z ADMIN_EMAILS).
 * Konfiguracja Stripe jest kompletna: plany mają realne price_id, paczki żyją
 * w `credit_packages`, kupony topup są ustawione.
 *
 * Jedyny wyjątek — decyzja 2026-08-22 (#56): członek biura NIE kupuje nic sam.
 * Cennik, paczki i plany to sprawa właściciela agencji; kredyty i plany zasilają
 * wspólną pulę. UI to ukrywa, ale prawdziwą bramką jest API.
 *
 * Wszystkie CTA zakupowe (RailNav/SubNav/Topbar/AccountPage/PricingPage/PlanGate)
 * czytają tę flagę — schowanie płatności z powrotem to jedna zmiana tutaj.
 */
import { useCredits } from "@/hooks/useCredits";

export function useCreditPurchase(): { visible: boolean; isLoading: boolean } {
  // isLoading obejmuje zapytanie o kredyty: rola agencyjna przychodzi z niego,
  // więc decyzja przed jego końcem byłaby zgadywaniem — a `null` w trakcie
  // ładowania wygląda identycznie jak „user solo". CTA mignęłyby członkowi biura.
  const { agencyRole, agencyId, isLoading: creditsLoading } = useCredits();
  // Fail-closed: znana agencja bez znanej roli (błąd zapytania, stary kształt
  // odpowiedzi) = traktuj jak członka, nie jak właściciela.
  const isMemberNotOwner = agencyId !== null && agencyRole !== "owner";
  // `visible` jest false TAKŻE w trakcie ładowania: część call-site'ów ignoruje
  // isLoading, a fail-open pokazywałby członkowi biura CTA na ~300 ms zapytania
  // o kredyty. Krótkie „doładuj pojawia się po chwili" jest tańsze niż klikalny
  // przycisk prowadzący do odmowy MEMBER_CANNOT_PURCHASE.
  return { visible: !creditsLoading && !isMemberNotOwner, isLoading: creditsLoading };
}
